import * as React from "react"
// @ts-ignore
import { saHomeImageFaq, saHomeImageFaqRows, saHomeImageFaqItemImage, saHomeImageFaqItem, saHomeImageFaqItemTextblock, saHomeImageFaqItemIcon, saHomeImageFaqItemTitleContainer, saHomeImageFaqItemTitle, saHomeImageFaqItemText, saHomeImageFaqList, saFaqListItem, saHomeImageFaqBtn, saQ, saA } from './saHomeImageFaq.module.scss'

import { SaTitle } from "../saTitle/saTitle"
import { SaButton } from "../saButton/saButton"
import SaFaqList from "../saFAQ/saFaqList"
import { saInterfaceImageTextFaq } from "../saTypes"
import SaImage from "../saImage/saImage"
import SaSwitchIcons from "../saSwitchIcons/saSwitchIcons"
import useWindowSize from "../saUseWindowDimensions/saUseWindowDimensions"
import { useLocation } from "@reach/router"






const SaHomeImageFaq:React.FC<Array<saInterfaceImageTextFaq>> = (props) =>  {


  const { windowWidth } = useWindowSize()

    let list: any = Object.values(props);

    let listClass: object = {
      list: saHomeImageFaqList,
      item: saFaqListItem,
      q: saQ,
      a: saA
    }




    let checkTitleDesc = (title) => {
      if (windowWidth >= 768){
        return (
          <div className={saHomeImageFaqItemTitleContainer}>
            <SaTitle title={title} classes={saHomeImageFaqItemTitle}/>
          </div>
        )
      }
    }

    let checkTitleMob = (title) => {
      if (windowWidth < 768){
        return (<div className={saHomeImageFaqItemTitleContainer}>
          <SaTitle title={title} classes={saHomeImageFaqItemTitle}/>
        </div>)
      }
    }




    let listItems =  list.map((item,index)  => (


        <div key={index} className={saHomeImageFaqItem}>

          {checkTitleMob(item.title)}


          {
            item.image &&
            <div className={saHomeImageFaqItemImage}>
              {
                item.icon && (item.icon !== 'null') &&
                <div className={saHomeImageFaqItemIcon}>
                  <SaSwitchIcons icon={item.icon} />
                </div>
              }
              <SaImage {...item.image}/>
            </div>
          }


          <div className={saHomeImageFaqItemTextblock}>

            {item.title && checkTitleDesc(item.title)}


            {
              item.text &&
              <div className={saHomeImageFaqItemText}
                   dangerouslySetInnerHTML={{__html: item.text}}/>
            }


            {
              item.faq &&
              <div className={saHomeImageFaqList}>
                <SaFaqList faq={item.faq} classes={listClass}/>
              </div>
            }

            {
              item.button &&
              <div className={saHomeImageFaqBtn}>
                <SaButton {...item.button}/>
              </div>
            }

          </div>

        </div>

      )
    )

    return (
      <div className={'saContainer ' + saHomeImageFaq}>

        <div className={saHomeImageFaqRows}>
          { listItems }
        </div>

      </div>
    )

}

export default SaHomeImageFaq